import React from 'react';

/**
 * IB-755 — Budget Versions v2.
 *
 * Linear committed-proportion bar. The `proportion` prop is a 0-100 percentage
 * already clamped server-side; it is clamped again here defensively so the fill
 * never overflows the track.
 */
export default function ProportionBar({ proportion = 0 }) {
    const clamped = Math.max(0, Math.min(100, Number(proportion) || 0));

    return (
        <div className="tw-flex tw-w-full tw-items-center tw-gap-x-2">
            <div className="tw-h-1.5 tw-flex-1 tw-rounded-full tw-bg-charcoal-15 tw-overflow-hidden">
                <div className="tw-h-full tw-rounded-full tw-bg-blue" style={{ width: `${clamped}%` }} />
            </div>
            <span className="tw-shrink-0 tw-text-xs tw-text-charcoal-50">{Math.round(clamped)}%</span>
        </div>
    );
}
